import { InvitationStatus } from '@taxora-api-models';

export class LoadActivity {
  static readonly type = '[ActivityState] LoadActivity';
  constructor(
    public params: {
      organizationId: number;
      status?: InvitationStatus;
      page?: number;
      limit?: number;
    },
  ) {}
}

export class ResetActivity {
  static readonly type = '[ActivityState] ResetActivity';
}

export class CreateInvitation {
  static readonly type = '[ActivityState] CreateInvitation';
  constructor(
    public email: string,
    public senderOrganizationId: number,
  ) {}
}
